module.exports = __webpack_public_path__ + "static/3-e01d9c779a2e87ddacd2e43577badd3f.png";